import { createElement, lazy } from 'react';
import type { RouteObject } from 'react-router';

import { urls } from '@treneo/shared/constants';
import type { RouteModule } from '@treneo/shared/router';
import { PublicLayoutRoute } from '@treneo/shared/ui';

const InviteAcceptPage = lazy(() =>
  import('./pages/invite-accept-page/invite-accept-page').then(module => ({
    default: module.InviteAcceptPage
  }))
);

const SystemOrganizationsRoute = lazy(() =>
  import('./pages/system-organizations-route/system-organizations-route').then(module => ({
    default: module.SystemOrganizationsRoute
  }))
);

const SystemInvitationsPage = lazy(() =>
  import('./pages/system-invitations-page/system-invitations-page').then(module => ({
    default: module.SystemInvitationsPage
  }))
);

export const getTrainerInvitePublicRoutes = (): RouteObject[] => [
  {
    element: createElement(PublicLayoutRoute),
    children: [
      {
        path: urls.routePaths.trainerInviteByToken,
        element: createElement(InviteAcceptPage)
      }
    ]
  }
];

export const getOrganizationsRouteModule = (): RouteModule => ({
  id: 'organizations',
  routes: [
    {
      path: urls.adminOrganizationsPage,
      element: createElement(SystemOrganizationsRoute)
    },
    {
      path: urls.adminInvitationsPage,
      element: createElement(SystemInvitationsPage)
    }
  ]
});
